export const invoiceCommand = {
  attest: 'attest',
  createAmortizationPlan: 'createAmortizationPlan',
  createReminder: 'createReminder',
  credit: 'credit',
  creditAll: 'creditAll',
  customerLoss: 'customerLoss',
  debtCollection: 'debtCollection',
  deleteMany: 'deleteMany',
  getpdf: 'getpdf',
  getpdfWithRegulations: 'getpdfWithRegulations',
  registerPayment: 'registerPayment',
  regulateFromBalance: 'regulateFromBalance',
  setDefermentDate: 'setDefermentDate',
  send: 'send',
  export: 'export',
  exportWithInvoiceRows: 'exportWithInvoiceRows',
};
